/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".expanded-toolbar[_ngcontent-%COMP%]{-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center}.mat-toolbar[_ngcontent-%COMP%]{background-color:#663399}.mat-form-field[_ngcontent-%COMP%]{width:50%}.block[_ngcontent-%COMP%]{display:block;width:70px;height:90px;border:none;color:#fff;font-size:18px;cursor:pointer;text-align:center}"];
export { styles as styles };
